import { useMutation } from "@tanstack/react-query";
import { api } from "../../../../../lib/api";

export const useDeleteEvent = (callback: () => void) => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (id: string) => api.delete(`/api/v1/events/${id}`),
    onSuccess: callback,
  });

  return [mutateAsync, isPending] as const;
};
